import React, { memo, useCallback } from "react";
import { Button } from "@narmi/design_system";
import { useNotificationContext } from "cerulean";
import ApiHttp from "byzantine/src/ApiHttp";
import { useLocalization } from "@fluent/react";

interface NoAlertsProps {
  fetchAlerts: () => void;
  setIsLoading: (isLoading: boolean) => void;
}

const NoAlerts = memo(({ fetchAlerts, setIsLoading }: NoAlertsProps) => {
  const { l10n } = useLocalization();
  const { sendNotification } = useNotificationContext();

  const submitDefaultAlert = useCallback(() => {
    setIsLoading(true);
    const payload = {
      filters: null,
      query: " balance<25 ",
      alert_type: "email",
    };
    ApiHttp.fetch("saved_searches", { method: "POST" }, payload)
      .then(() => {
        fetchAlerts();
        sendNotification({
          type: "success",
          text: l10n.getString(
            "alerts-toast-success-create",
            {},
            "Alert created."
          ),
        });
      })
      .finally(() => setIsLoading(false));
  }, [setIsLoading, fetchAlerts, sendNotification, l10n]);

  return (
    <div>
      <span className="fontWeight--semibold">
        {l10n.getString(
          "custom-alerts-label-no-alerts",
          {},
          "You have no active alerts."
        )}
      </span>
      <p className="margin--top--s">
        {l10n.getString(
          "custom-alerts-label-set-new-alert",
          {},
          "Try setting one up:"
        )}{" "}
        <Button kind="plain" onClick={submitDefaultAlert}>
          {l10n.getString(
            "custom-alerts-label-default-alert",
            {},
            "Email me when a transaction drops my resulting balance below $25."
          )}
        </Button>
      </p>
    </div>
  );
});

export default NoAlerts;
